const FromArr = [{
	title: "L1产品线：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "选择L1产品线",
	width: 190,
	height: 32,
	disabled: false,
	marginLeft: 30,
	marginTop: 0,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	collapseTags: true,
}, {
	title: "日期：",
	StartTime: '',
	EndTime: '',
	inputtype: "dateSection",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "date",
	placeholder: "选择日期",
	heightLeft: 32,
	heightRight: 32,
	widthLeft: 150,
	widthRight: 150,
	disabled: false,
	marginLeft: 80,
	marginTop: 0,
	displayVal: "inline-block",
	fontWeightVal: 500
}, {
	title: "大区经理：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	multiple: true,
	placeholder: "选择大区经理",
	width: 230,
	height: 32,
	disabled: false,
	marginLeft: 100,
	marginTop: 0,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	collapseTags: true,
}, {
	title: "地区经理：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	multiple: true,
	placeholder: "选择地区经理",
	width: 190,
	height: 32,
	disabled: false,
	marginLeft: 30,
	marginTop: 14,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	collapseTags: true,
}, {
	title: "省份：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "选择省份",
	width: 210,
	height: 32,
	disabled: false,
	marginLeft: 80,
	marginTop: 14,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: []
}, {
	title: "经销商：",
	inputtype: "selectMultiple",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	multiple: true,
	placeholder: "选择经销商",
	width: 230,
	height: 32,
	disabled: false,
	marginLeft: 235,
	marginTop: 14,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	remoteMethod: 'customMethod',
	collapseTags: true,
}]

const FromArr2 = [{
	title: "L1产品线：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "选择L1产品线",
	width: 210,
	height: 32,
	disabled: false,
	marginLeft: 30,
	marginTop: 20,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	collapseTags: true,
}, {
	title: "产品分类（L3）：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	multiple: true,
	placeholder: "选择产品分类",
	width: 210,
	height: 32,
	disabled: false,
	marginLeft: 120,
	marginTop: 20,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	collapseTags: true,
}, {
	title: "大区经理：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	multiple: true,
	placeholder: "选择大区经理",
	width: 230,
	height: 32,
	disabled: false,
	marginLeft: 100,
	marginTop: 20,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	collapseTags: true,
}, {
	title: "地区经理：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	multiple: true,
	placeholder: "选择地区经理",
	width: 210,
	height: 32,
	disabled: false,
	marginLeft: 30,
	marginTop: 20,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	collapseTags: true,
}, {
	title: "省份：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "选择省份",
	width: 210,
	height: 32,
	disabled: false,
	marginLeft: 185,
	marginTop: 14,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: []
}, {
	title: "经销商：",
	inputtype: "selectMultiple",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	multiple: true,
	placeholder: "选择经销商",
	width: 230,
	height: 32,
	disabled: false,
	marginLeft: 115,
	marginTop: 14,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	remoteMethod: 'customMethod',
	collapseTags: true,
}]


const FromArr3 = [{
	title: "L1产品线：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "选择L1产品线",
	width: 230,
	height: 32,
	disabled: false,
	marginLeft: 50,
	marginTop: 0,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	collapseTags: true,
}, {
	title: "产品分类（L3）：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	multiple: true,
	placeholder: "选择产品分类",
	width: 230,
	height: 32,
	disabled: false,
	marginLeft: 80,
	marginTop: 0,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	collapseTags: true,
}, {
	title: "大区经理：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	multiple: true,
	placeholder: "选择大区经理",
	width: 230,
	height: 32,
	disabled: false,
	marginLeft: 80,
	marginTop: 0,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	collapseTags: true,
}, {
	title: "地区经理：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	multiple: true,
	placeholder: "选择地区经理",
	width: 230,
	height: 32,
	disabled: false,
	marginLeft: 50,
	marginTop: 14,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	collapseTags: true,
}, {
	title: "销售代表：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	multiple: true,
	placeholder: "选择销售代表",
	width: 230,
	height: 32,
	disabled: false,
	marginLeft: 125,
	marginTop: 14,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	collapseTags: true,
}, {
	title: "省份：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "选择省份",
	width: 230,
	height: 32,
	disabled: false,
	marginLeft: 108,
	marginTop: 14,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: []
}, {
	title: "经销商：",
	inputtype: "selectMultiple",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	multiple: true,
	placeholder: "选择经销商",
	width: 230,
	height: 32,
	disabled: false,
	marginLeft: 65,
	marginTop: 14,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	remoteMethod: 'customMethod',
	collapseTags: true,
}]

const FromArr4 = [{
	title: "年份：",
	inputtype: "year",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "选择年份",
	width: 130,
	height: 32,
	disabled: false,
	marginLeft: 30,
	marginTop: 0,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: []
}, {
	title: "产品线：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "选择产品线",
	width: 130,
	height: 32,
	disabled: false,
	marginLeft: 30,
	marginTop: 0,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	collapseTags: true,
}, {
	title: "产品分类（L3）：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	multiple: true,
	placeholder: "选择产品分类",
	width: 190,
	height: 32,
	disabled: false,
	marginLeft: 30,
	marginTop: 0,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	collapseTags: true,
}, {
	title: "月份：",
	StartTime: '',
	EndTime: '',
	inputtype: "monthSection",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	placeholder: "选择月份",
	heightLeft: 32,
	heightRight: 32,
	widthLeft: 130,
	widthRight: 130,
	disabled: false,
	marginLeft: 50,
	marginTop: 0,
	displayVal: "inline-block",
	fontWeightVal: 500
}]

const tableHead = [{
	"label": '省份',
	"key": 'ProvinceName',
	"width": "auto",
}, {
	"label": '数量',
	"key": 'Quantity',
	"width": "auto"
}, {
	"label": 'GTS',
	"key": 'StandardSum',
	"width": "auto"
}]

export {
	FromArr,
	FromArr2,
	FromArr3,
	FromArr4,
	tableHead
}